module.exports = __webpack_public_path__ + "img/paper-clip.23bd4656.png";